import React from 'react';
import PhotoGallery from '../common/PhotoGallery';
import '../../css/about.css';

// Screenshots of pdubfantasy.com — our PWHL fantasy hockey product
const galleryImages = [
  { url: '/img/pdubfantasy/home.png',           alt: 'PdubFantasy Home',          caption: 'PdubFantasy — PWHL Fantasy Hockey' },
  { url: '/img/pdubfantasy/home_bottom.png',    alt: 'Home Page — Game Cards',    caption: 'Game previews, social embeds, and more on the home page' },
  { url: '/img/pdubfantasy/hub_players.png',    alt: 'Player Stats Hub',          caption: 'Player Stats Hub with real-time scoring' },
  { url: '/img/pdubfantasy/player_profile.png', alt: 'Player Profile — Kelly Pannek', caption: 'Player profiles with full career stats' },
  { url: '/img/pdubfantasy/standings.png',      alt: 'PWHL Standings',            caption: 'Live PWHL team standings' },
  { url: '/img/pdubfantasy/news.png',           alt: 'PWHL News Feed',            caption: 'Aggregated PWHL news from across the web' },
  { url: '/img/pdubfantasy/moves.png',          alt: 'Player Moves & Transactions', caption: 'Signings, trades, and retirements timeline' },
  { url: '/img/pdubfantasy/game_map.png',       alt: 'Interactive Game Map',      caption: 'Interactive game map across North America' },
  { url: '/img/pdubfantasy/trends.png',         alt: 'Player & Team Trends',      caption: 'AI-powered player and team trend analysis' },
  { url: '/img/pdubfantasy/schedule.png',       alt: 'PWHL Schedule',             caption: 'Full PWHL season schedule' },
  { url: '/img/pdubfantasy/prospects.png',      alt: 'Prospects Database',        caption: 'NCAA & Olympic prospects database' },
  { url: '/img/pdubfantasy/leagues_public.png', alt: 'Browse Public Leagues',     caption: 'Browse and join 400+ public fantasy leagues' },
];

const About = () => {

  return (
    <div className="about-page">
      <section className="about-section">
        <div className="container">
          <h1>About Us</h1>
          <p>Welcome to UnsupervisedBias, your trusted partner in AI-driven data automation solutions.</p>
          <p>
            UnsupervisedBias was founded on the belief that AI can transform a business. We are committed to
            developing innovative solutions that help businesses overcome obstacles, streamline
            operations, and get ahead of the competition.
          </p>
          <p>
            Our expertise spans AI, data, marketing, and business development, united by a passion for
            delivering innovative solutions with transparent communication throughout the development
            process.
          </p>

          {/* Core Values Section */}
          <h2>Our Core Values</h2>
          <p>
            At UnsupervisedBias, our core values guide every decision we make and every service we provide.
            They are the foundation of our commitment to helping you achieve success:
          </p>

          <h3>❤️ Empathy</h3>
          <p>
            Above all other values, we believe in understanding and sharing the feelings of our customers. By
            putting ourselves in your shoes, we create solutions that truly meet your needs, fostering
            strong, supportive relationships along the way.
          </p>

          <h3>🛡️ Integrity</h3>
          <p>
            We uphold honesty and strong moral principles in every action we take. Our commitment to
            integrity means that we handle your data with the highest ethical standards, ensuring
            transparency and trust in all our dealings.
          </p>

          <h3>🚀 Innovation</h3>
          <p>
            In the rapidly evolving field of AI, we continuously seek creative solutions and embrace new
            ideas. Our passion for innovation drives us to explore cutting-edge technologies, ensuring that
            we deliver the most advanced and effective solutions for your business.
          </p>

          <h3>🎯 Accuracy</h3>
          <p>
            Precision and correctness are at the heart of what we do. We are committed to delivering accurate
            data analyses and insights, ensuring that you can rely on the information we provide to make
            informed decisions.
          </p>

          <h3>⚡ Efficiency</h3>
          <p>
            We strive for optimal and effective ways to achieve your goals. By streamlining processes and
            automating tasks, we save you time and resources, allowing you to focus on what matters
            most—your customers.
          </p>

          <h3>🌊 Adaptability</h3>
          <p>
            In a fast-paced industry, finding flow with our customers is key. We thrive in changing
            environments, quickly adapting to new challenges and opportunities to keep your business ahead of the curve.
          </p>

          <h2>Contact Us</h2>
          <p>
            If you have any questions or would like to learn more about our services, feel free to{' '}
            <a href="/contact" style={{ color: 'var(--pink)' }}>contact us</a>.
          </p>

          {/* Photo Gallery Section */}
          <h2 style={{ marginTop: '60px' }}>Our Work</h2>
          <p>A look at <a href="https://pdubfantasy.com" target="_blank" rel="noopener noreferrer" style={{ color: 'var(--pink)' }}>PdubFantasy</a> — our PWHL fantasy hockey platform built with real-time stats, AI-powered analytics, and a full fantasy league system.</p>
          <PhotoGallery images={galleryImages} />
        </div>
      </section>
    </div>
  );
};

export default About;
